import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full max-w-prose mx-auto px-5 pb-10 pt-6 mt-8 border-t border-line">
      <p className="text-sm text-faint mb-0">© 2026 Giorgio Zinetti</p>
    </footer>
  );
};

export default Footer;
